<template>
  <div v-if="user && invoice_user">
    <section class="payments_page_top">
      <div class="container">
        <div class="table_head flx">
          <div class="balance_container">
            <span class="bal_count">{{ user.balance || 0 }} <span>грн</span></span>
            <span>Текущий Баланс</span>
          </div>
          <div class="profit_container">
            <span class="profit_count"><b class="green">{{ invoice_user.billing_info.pay * -1 }} <span class="green"> грн </span></b><b class="red"> {{invoice_user.billing_info.debit * -1}} <span
              class="red">грн</span></b></span>
            <span class="grey"><b>Прибыль</b></span>
          </div>
          <!--          <div class="progress_bar_container flx">-->
          <!--            <div class="progress_bar_wrap">-->
          <!--              <div class="progress_line" style="width: 60%;"></div>-->
          <!--            </div>-->
          <!--            <div class="level_wrap">-->
          <!--              <span class="grey">Сделайте еще 35 заказов в этом месяце</span>-->
          <!--              <span class="grey">И получите уровень<span class="level">PRO</span> <span-->
          <!--                class="info_green_ico"></span></span>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </section>
    <section class="payments_general" style="min-height: 300px">
      <div class="container requests_container flx">
        <div class="left_box">
          <div class="btn open_pop" data-id="calculate" @click="toggleDeductionModal()" :class="{'disabled': invoice_user.deduction}">
            <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.92016 2.65967H2.09337C1.48952 2.65967 1 3.14919 1 3.75304V11.4066C1 12.0105 1.48952 12.5 2.09337 12.5H9.74695C10.3508 12.5 10.8403 12.0105 10.8403 11.4066V7.57983"
                stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10.0205 1.83967C10.4733 1.38678 11.2076 1.38678 11.6605 1.83967C12.1134 2.29255 12.1134 3.02683 11.6605 3.47972L6.46701 8.67322L4.28027 9.21991L4.82696 7.03317L10.0205 1.83967Z"
                    stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Запросить выплату</span>
          </div>
          <div class="btn blue_btn open_pop" data-id="calculate">
            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.33231 4.9122C7.25823 5.13305 7.13668 5.36207 6.96768 5.59399C6.94816 4.78744 6.6892 3.90787 6.20726 2.97498C5.74673 2.07991 5.1042 1.37739 4.299 0.887039L3.73523 0.544716C3.52051 0.413717 3.26906 0.589939 3.27953 0.822205L3.30957 1.49875C3.32924 1.94246 3.27883 2.32447 3.16671 2.63432C3.02369 3.03012 2.81827 3.39784 2.55547 3.72813C2.37251 3.95774 2.16521 4.16535 1.93752 4.34708C1.33875 4.82216 0.852223 5.43057 0.514058 6.12654C0.176512 6.82903 0.000411611 7.60299 0 8.3867C0 9.07733 0.131945 9.747 0.393168 10.3785C0.645264 10.9861 1.00925 11.538 1.46506 12.0033C1.92456 12.4716 2.45874 12.8413 3.05437 13.0981C3.67126 13.3651 4.32535 13.5 4.99999 13.5C5.67459 13.5 6.32849 13.3651 6.94514 13.0997C7.53935 12.8445 8.07941 12.4723 8.53527 12.0043C8.99511 11.5355 9.35566 10.9875 9.60679 10.3799C9.86762 9.75021 10.0014 9.0724 9.99999 8.38782C9.99994 7.67374 9.85802 6.97939 9.57563 6.3248C9.30014 5.68494 8.89953 5.11032 8.39864 4.637L8.00022 4.25974L7.99924 4.25884C7.96243 4.22494 7.91775 4.20056 7.86898 4.18824C7.82019 4.17592 7.76916 4.17615 7.72049 4.18889C7.67184 4.20164 7.62737 4.22641 7.59086 4.26063C7.55437 4.29482 7.52694 4.33737 7.51059 4.38434L7.33231 4.9122ZM7.60841 11.0484C8.30339 10.3379 8.68662 9.39325 8.68662 8.38821C8.68662 7.86223 8.58138 7.35151 8.37473 6.87133C8.29104 6.67632 8.1924 6.49093 8.0794 6.31591C7.97932 6.46006 7.86872 6.60181 7.74815 6.74121C7.5346 6.98663 7.23914 7.13426 6.91726 7.15129C6.75895 7.16061 6.60047 7.13742 6.45108 7.08314C6.30156 7.02882 6.16427 6.9445 6.04706 6.8353C5.91203 6.71007 5.80657 6.55521 5.73828 6.38251C5.66998 6.20976 5.64058 6.02346 5.65214 5.83754C5.6901 5.21791 5.49537 4.46919 5.04814 3.6041C4.88701 3.2952 4.7042 3.02121 4.49714 2.78102C4.46909 2.88961 4.43608 2.99686 4.39819 3.10239C4.20524 3.6368 3.92709 4.13481 3.57271 4.58103C3.32789 4.89088 3.04869 5.17018 2.74076 5.4132C2.29926 5.76298 1.93549 6.21759 1.69155 6.72508C1.44078 7.24536 1.31337 7.80429 1.31337 8.38821C1.31337 9.39314 1.69653 10.3365 2.3917 11.0485C3.08919 11.7616 4.01374 12.1521 4.99999 12.1521C5.98631 12.1521 6.91092 11.7615 7.60841 11.0484Z"
                    fill="white"/>
            </svg>
            <span>Запросить моментальную выплату</span>
          </div>
          <div class="info_wrap">
            <span class="info_grey_ico"></span>
            <div class="menu_drop info_btn">
              <div class="dropdown">
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat temporibus consequuntur consectetur
                  eum, sed doloribus voluptatum dolore aliquid blanditiis libero laborum quasi ullam! Officiis minima
                  sequi accusamus ducimus, similique adipisci.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="payment_wrap flx">
          <div class="item_wrap">
            <a href="#" class="item" :class="{'active':window_type===1}" @click="window_type=1">Заказы в ожидании выплат</a>
            <a href="#" class="item" :class="{'active':window_type===2}" @click="window_type=2">Выплаты</a>
          </div>
        </div>
      </div>
      <div class="container has_table">
<!--        PENDING ORDERS-->
        <pending-orders v-if="window_type === 1" :opened_invoices="opened_invoices" :opened_pagination="opened_pagination"/>
        <!--        REPORTS-->
        <payment-reports v-if="window_type === 2" ></payment-reports>
      </div>
    </section>
    <div v-if="show_modal" class="popup_box" style="display: block" data-id="calculate">
      <div class="popup calculate" v-if="pre_create_data">
        <span class="page_title">Запросить выплату</span>
        <span class="close_popup" @click="setShowModal(false)"></span>
        <div class="wrap_three_items flx">
          <div class="inp_wrap">
            <p>Заказов:</p>
            <input type="text" v-model="pre_create_data.orders_count">
          </div>
          <div class="inp_wrap">
            <p>Возвратов:</p>
            <input type="text" v-model="pre_create_data.return_count">
          </div>
          <div class="inp_wrap">
            <p>С баланса:</p>
            <input type="text" v-model="pre_create_data.balance_count">
          </div>
        </div>
        <div class="wrap_two_items flx">
          <div class="inp_wrap">
            <p>Прибыль:</p>
            <input type="text" v-model="pre_create_data.pay">
          </div>
          <div class="inp_wrap">
            <p>Расходы:</p>
            <input type="text" v-model="pre_create_data.debit">
          </div>
        </div>
        <div class="inp_wrap payment">
          <p>Сумма выплаты на сегодняшний день:</p>
          <span class="amount_payment">{{pre_create_data.total}} <span>грн</span>
        <div class="wrap flx"><span class="info_grey_ico"> </span>
          <div class="menu_drop">
            <div class="dropdown">
              <p>В момент расчёта нашими менеджерами, сумма выплаты может измениться в зависимости от новых заказов</p>
            </div>
          </div>
        </div>
        </span>
        </div>
        <div class="inp_wrap textarea">
          <p>Комментарий:</p>
          <textarea v-model="comment"></textarea>
        </div>
        <button class="btn" @click="createDeductionRequest()">Запросить</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import helper from '../../../helpers/helper'
import PendingOrders from '../../../components/modules/Payments/PendingOrders'
import PaymentReports from '../../../components/modules/Payments/PaymentReports'

export default {
  name: 'PaymentsPage',
  components: { PendingOrders, PaymentReports },
  metaInfo () {
    return {
      title: 'Выплаты - Личный кабинет'
    }
  },
  data () {
    return {
      window_type: 1,
      page: 1,
      perPage: 10,
      page_sizes: [10, 30, 50],
      comment: null
    }
  },
  pageClass: 'cabinet-page payments-page',
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('invoices', ['opened_invoices', 'invoice_user', 'opened_pagination']),
    ...mapState('deductions', ['pre_create_data', 'invoices', 'show_modal'])
  },
  methods: {
    ...mapActions('payments', ['getPayments']),
    ...mapActions('invoices', ['getOpenedInvoices', 'getInvoiceUser']),
    ...mapActions('deductions', ['preCreate', 'createDeduction']),
    ...mapMutations('deductions', ['setShowModal']),
    toggleDeductionModal () {
      if (this.invoice_user.deduction) {
        return
      }
      this.preCreate()
      this.setShowModal(!this.show_modal)
    },
    getOrderStatusColor (order) {
      return helper.getOrderStatusColor(order.status)
    },
    createDeductionRequest () {
      this.createDeduction({
        comment: this.comment,
        invoice_ids: this.invoices
      })
      this.getInvoiceUser()
    }
  },
  created () {
    this.getOpenedInvoices()
  }
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
}
</style>
